import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import { CustomAvatar } from '../../../components/custom-avatar';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user } = useAuthContext();
  const [decodedJwt, setDecodedJwt] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('jwtTokenLocal');
    // console.log(token, 'token---------000000');

    if (token) {
      const decoded = jwtDecode(token);
      setDecodedJwt(decoded);
    }

    // console.log(token, 'toeknnnnnnnnnnn');

    // urlJwtToken
  }, []);

  console.log(decodedJwt, 'decodedJwt');

  return (
    <Box>
      {/* <Link component={RouterLink} to={PATH_DASHBOARD.user.account} underline="none" color="inherit"> */}
      <StyledRoot>
        {/* <CustomAvatar src={user?.photoURL} alt={user?.displayName} name={user?.displayName} /> */}
        <CustomAvatar
          src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
          alt={user?.displayName}
          name={user?.displayName}
        />

        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {/* {user?.displayName} */}
            {decodedJwt?.name}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            {/* {user?.role} */}
            {decodedJwt?.roleCode}
          </Typography>
        </Box>
      </StyledRoot>
    </Box>
    // </Link>
  );
}
